'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.isReturningUser = exports.UserRolesUpdated = void 0;
var vue_class_component_1 = require("vue-class-component");
var functions_1 = require("./functions");
var magic_sdk_1 = require("@gig/magic-sdk");
var RETURNING_USER_KEY = 'returning-user';
/**
 * Decorator to react to user role updated events and automatically
 * unsubscribe after the component has been destroyed
 *
 * Decorated method will be called with the current logged in status.
 */
var UserRolesUpdated = function () {
    return vue_class_component_1.createDecorator(function (options, key) {
        if (!options.methods) {
            options.methods = {};
        }
        var functionToCall = options.methods[key];
        if (functionToCall && typeof functionToCall === 'function') {
            var subscriptions_1 = [];
            options.created = functions_1.hookFunction(options.created, function () {
                var _this = this;
                var handler = function (event) {
                    if (!!event.addedRoles || !!event.removedRoles) {
                        functionToCall.call(_this, event);
                    }
                };
                subscriptions_1.push(magic_sdk_1.magic.events.userUpdated(function (updateEvent) {
                    return handler(updateEvent);
                }).unsub);
            });
            options.beforeDestroy = functions_1.hookFunction(options.beforeDestroy, function () {
                subscriptions_1.forEach(function (unsub) {
                    unsub();
                });
            });
        }
    });
};
exports.UserRolesUpdated = UserRolesUpdated;
/**
 * Checks if the user is a returning customer.
 */
function isReturningUser() {
    try {
        return !!window.localStorage.getItem(RETURNING_USER_KEY);
    }
    catch (_a) {
        return true;
    }
}
exports.isReturningUser = isReturningUser;
